module.exports = __webpack_public_path__ + "static/media/proof-of-enrollment.f9341d8e.svg";